'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var reservationCampaignComponent = exports.reservationCampaignComponent = {
    template: require('./reservation-campaign.html'),
    bindings: {
        campaign: '<'
    },
    controllerAs: 'vm',
    controller: ["common", "gettextCatalog", "reservationCampaignService", "Analytics", "toastr", function reservationCampaignController(common, gettextCatalog, reservationCampaignService, Analytics, toastr) {
        'ngInject';

        var vm = this;
        vm.$onInit = init;
        vm.saveAmounts = saveAmounts;

        function init() {
            common.setTitle(vm.campaign.campaign.code);
            vm.displayUnits = vm.campaign.reservations.every(function (reservation) {
                return reservation.unit;
            }) ? false : true;
            Analytics.trackPage('/' + common.localization.getCurrentLanguage() + '/reservations', vm.campaign.campaign.code);
        }

        function saveAmounts() {
            if (validateLines()) {
                reservationCampaignService.setReservationCampaign(vm.campaign.campaign.code, vm.campaign.reservations).then(function (response) {
                    vm.campaign = response;
                    toastr.success(gettextCatalog.getString('_reservationCampaigns.reservationConfirmed'), '', {
                        progressBar: true,
                        timeOut: 5000,
                        extendedTimeOut: 1000,
                        closeButton: true
                    });
                });
            }
        }

        function validateLines() {
            var valid = true;
            vm.campaign.reservations.forEach(function (product) {
                if (product.limit && product.limit < product.amount) {
                    product.limitReached = gettextCatalog.getString('_reservationCampaigns.limitReached', { limit: product.limit });
                    valid = false;
                }
            });
            return valid;
        }
    }]
};


//////////////////
// WEBPACK FOOTER
// ./features/reservation-campaign/reservation-campaign.js
// module id = 1005
// module chunks = 0